/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Chip_UnpaidInputs */

const vi_order_payment_chip_unpaid = /** @type {(inputs: Order_Payment_Chip_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa TT`)
};

/**

* @param {Order_Payment_Chip_UnpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_chip_unpaid = /** @type {((inputs?: Order_Payment_Chip_UnpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Chip_UnpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_chip_unpaid(inputs)
});